export var RuleFormTab;
(function (RuleFormTab) {
    RuleFormTab["InfoAndTriggers"] = "infoAndTriggers";
    RuleFormTab["CurateResults"] = "curateResults";
    RuleFormTab["Ranking"] = "ranking";
    RuleFormTab["Navigations"] = "navigations";
    RuleFormTab["Facets"] = "facets";
    RuleFormTab["Content"] = "content";
    RuleFormTab["RuleExperiment"] = "ruleExperiment";
    RuleFormTab["Analytics"] = "analytics";
})(RuleFormTab || (RuleFormTab = {}));
export const TAB_NAMES = [
    RuleFormTab.InfoAndTriggers,
    RuleFormTab.CurateResults,
    RuleFormTab.Ranking,
    RuleFormTab.Navigations,
    RuleFormTab.Facets,
    RuleFormTab.Content,
];
export const RULE_VARIANT_TAB_NAMES = [
    RuleFormTab.CurateResults,
    RuleFormTab.Ranking,
    RuleFormTab.Navigations,
    RuleFormTab.Content,
];
export const RULE_FORM_TAB_NAMES_TO_MESSAGE_KEY = {
    [RuleFormTab.InfoAndTriggers]: 'INFO_AND_TRIGGERS',
    [RuleFormTab.CurateResults]: 'RECALL',
    [RuleFormTab.Ranking]: 'RANKING',
    [RuleFormTab.Navigations]: 'FACETS',
    [RuleFormTab.Facets]: 'FACETS',
    [RuleFormTab.Content]: 'RULE_TAB_CONTENT',
    [RuleFormTab.RuleExperiment]: 'EXPERIMENT',
    [RuleFormTab.Analytics]: 'ANALYTICS',
};
export const VARIANT_MAX_LIMIT = 5;
export const VARIANT_MIN_LIMIT = 2;
export var RuleDragType;
(function (RuleDragType) {
    RuleDragType["ProductPreview"] = "productPreview";
    RuleDragType["ChipTier"] = "chipTier";
})(RuleDragType || (RuleDragType = {}));
export const HISTORY_KEYS = {
    Experiment: {
        title: (variant) => ({
            key: 'DYNAMIC_PREVIEW_EXPERIMENT_VARIANT_APPLIED',
            values: { variant },
        }),
        stop: (winner) => ({
            key: 'DYNAMIC_PREVIEW_EXPERIMENT_FINISHED',
            values: { winner },
        }),
    },
    Ranking: {
        title: (rule) => ({
            key: 'DYNAMIC_PREVIEW_RULE_RANKING_APPLIED',
            values: { name: rule },
        }),
        pinnedProducts: (position, productId) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING' },
            conditions: [
                { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING_PINNED_PRODUCT', values: { value: productId, tier: position } },
            ],
        }),
        pinnedProductsOosOn: (position, productId) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING' },
            conditions: [
                { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING_PINNED_PRODUCT_OOS_ON', values: { value: productId, tier: position } },
            ],
        }),
        pinnedProductsOosOff: (position, productId) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING' },
            conditions: [
                { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING_PINNED_PRODUCT_OOS_OFF', values: { value: productId, tier: position } },
            ],
        }),
        pinnedProductsDeleted: (position, productId) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING' },
            conditions: [
                { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING_PINNED_PRODUCT_REMOVED', values: { value: productId, tier: position } },
            ],
        }),
        pinnedProductsCleared: () => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_PINNED_PRODUCTS_CLEARED' }],
        }),
        biasingStrategy: (newBias) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_BIASING', value: newBias }],
        }),
        biasingStrategyCleared: () => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_BIAS_CLEARED' }],
        }),
        boostedProductBuckets: (tier, boostedProducts) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING' },
            conditions: [
                { key: 'DYNAMIC_PREVIEW_HISTORY_TIER', values: { tier, value: boostedProducts.join(', ') } },
            ],
        }),
        boostedProductBucketsCleared: () => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING' },
            conditions: [
                { key: 'DYNAMIC_PREVIEW_HISTORY_PRODUCT_BOOSTED_CLEARED' },
            ],
        }),
        buriedProductBuckets: (buriedProducts) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_PRODUCT_BURIED', value: buriedProducts.join(', ') }],
        }),
        buriedProductBucketsCleared: () => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RANKING' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_PRODUCT_BURIED_CLEARED' }],
        }),
    },
    Recall: {
        title: (rule) => ({
            key: 'DYNAMIC_PREVIEW_RULE_RECALL_APPLIED',
            values: { name: rule },
        }),
        filterBySearch: (chips) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_FILTER_BY_SEARCH', value: chips.join(', ') }],
        }),
        filterBySearchCleared: () => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_FILTER_BY_SEARCH_CLEARED' }],
        }),
        productInclude: (products) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_PRODUCT_INCLUDED', value: products.join(', ') }],
        }),
        productExclude: (products) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_PRODUCT_EXCLUDED', value: products.join(', ') }],
        }),
        productCleared: () => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_PRODUCT_CLEARED' }],
        }),
        atributeInclude: (atribute, atributeValues) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_ATTRIBUTE_INCLUDED', value: `${atribute}: ${atributeValues.join(', ')}` }],
        }),
        atributeExclude: (atribute, atributeValues) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_ATTRIBUTE_EXCLUDED', value: `${atribute}: ${atributeValues.join(', ')}` }],
        }),
        atributeRemoved: () => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_ATTRIBUTE_REMOVED' }],
        }),
        atributeIncludeRange: (atribute, low, high) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_ATTRIBUTE_INCLUDED_RANGE', value: `${atribute}, ${low}-${high}` }],
        }),
        atributeExcludeRange: (atribute, low, high) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_ATTRIBUTE_EXCLUDED_RANGE', value: `${atribute}, ${low}-${high}` }],
        }),
        atributeIncludeValue: (atribute, atributeValues) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_ATTRIBUTE_INCLUDED_VALUE', value: `${atribute}: ${atributeValues.join(', ')}` }],
        }),
        atributeExcludeValue: (atribute, atributeValues) => ({
            title: { key: 'DYNAMIC_PREVIEW_HISTORY_RECALL_CHANGED' },
            conditions: [{ key: 'DYNAMIC_PREVIEW_HISTORY_ATTRIBUTE_EXCLUDED_VALUE', value: `${atribute}: ${atributeValues.join(', ')}` }],
        }),
    },
};
